import { FC, RefObject, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

interface SideBarHoursProps {
  containerOffset: RefObject<HTMLDivElement>;
}

const SideBarHours: FC<SideBarHoursProps> = ({ containerOffset }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => state?.user
  );

  const hours =
    currentLang === "ar"
      ? [
          "7 ص",
          "8 ص",
          "9 ص",
          "10 ص",
          "11 ص",
          "12 م",
          "1 م",
          "2 م",
          "3 م",
          "4 م",
          "5 م",
          "6 م",
          "7 م",
          "8 م",
          "9 م",
          "10 م",
          "11 م",
          "12 ص",
          "1 ص",
          "2 ص",
          "3 ص",
          "4 ص",
          "5 ص",
          "6 ص",
        ]
      : [
          "7 AM",
          "8 AM",
          "9 AM",
          "10 AM",
          "11 AM",
          "12 PM",
          "1 PM",
          "2 PM",
          "3 PM",
          "4 PM",
          "5 PM",
          "6 PM",
          "7 PM",
          "8 PM",
          "9 PM",
          "10 PM",
          "11 PM",
          "12 AM",
          "1 AM",
          "2 AM",
          "3 AM",
          "4 AM",
          "5 AM",
          "6 AM",
        ];

  const today = new Date();
  const time = today.getHours();
  useEffect(() => {
    // ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [ref.current]);

  return (
    <div
      className="col-start-1 col-end-2 row-start-1 grid "
      style={{
        gridTemplateRows: "repeat(24, minmax(5rem, 1fr))",
      }}
    >
      {hours.map((hour, index) => (
        <div
          ref={(index < 17 ? index + 7 : index + 7 - 24) === time ? ref : null}
          className="relative  border-y border-solid  border-gray-200 cursor-pointer z-10 "
          key={index}
        >
          <div
            className={
              currentLang === "ar"
                ? "absolute w-fit -right-14 top-1/2  -ml-14 -mt-2.5   pr-2 text-right leading-5 text-gray-400"
                : "absolute w-fit left-0 top-1/2  -ml-14 -mt-2.5   pr-2 text-right leading-5 text-gray-400"
            }
          >
            {hour}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SideBarHours;
